import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            form: {
                host: '',
                port: '',
                user: '',
                password: '',
                dir: '',
                domain: '',
                sitename: '',
                logo: null,
                enabled: false,
                connected: false,
            }
        }
    },
    mutations: {
        setForm: (state, value) => {
            window.Vue.set(state, 'form', value);
        }
    },
    actions: {
        remoteHostShow({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/remote-host/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        remoteHostConnect({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-host/connect/' + id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        remoteHostDisconnect({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-host/disconnect/' + id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        remoteHostUploadPages({state, commit, getters}, {id, form}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/remote-host/upload/' + id, form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                        reject(error);
                    });
            });
        },
        resetForm({state, commit}) {
            const properties = {
                logo: null,
                enabled: false,
                connected: false,
            };

            let form = {};

            Object.keys(state.form).forEach((property) => {
                if (properties.hasOwnProperty(property)) {
                    form[property] = properties[property];
                } else {
                    form[property] = '';
                }
            });

            commit('setForm', form);
        }
    }
};